import { UI_MESSAGES } from './ui';
import { SHOP_MESSAGES } from './shop';

const en = {
  nav: {
    home: 'Home',
    shop: 'Shop',
    articles: 'Articles',
    tunes: 'Tunes',
    abc: 'ABC',
    about: 'About',
    contact: 'Contact',
    faq: 'FAQ',
    search: 'Search',
    signUp: 'Sign Up',
    login: 'Login',
    profile: 'Profile',
    admin: 'Admin Dashboard',
    logout: 'Logout',
    account: 'Account',
    signedInAs: 'Signed in as',
    welcome: 'Welcome',
    installApp: 'Install App',
    language: 'Language',
    selectLanguage: 'Select language',
  },
  auth: {
    // Sign in
    loginTitle: 'Login',
    noAccount: "Don't have an account?",
    signUpHere: 'Sign Up here',
    forgotPassword: 'Forgot Password?',
    usernameOrEmail: 'Username or Email',
    usernameOrEmailPlaceholder: 'Enter your username or email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    loginButton: 'Login',
    loggingIn: 'Logging in...',
    welcomeBack: 'Welcome back!',
    invalidCredentials: 'Invalid username/email or password',
    loginFailed: 'Login failed. Please try again.',
    // Sign up
    signUpTitle: 'Sign Up',
    playerCalloutTitle: 'Music Player with 70+ Free Tunes!',
    playerCalloutText:
      'Sign up to unlock access to our exclusive Cape Breton fiddle tunes player',
    creatingAccountSpinner: 'Creating your account...',
    alreadyHaveAccount: 'Already have an account?',
    signInHere: 'Sign in here',
    forgotYourPassword: 'Forgot your password?',
    devHint:
      'Local testing: you can reuse the same email on multiple accounts if each username is unique. Sign in with your username when several accounts share an email.',
    firstName: 'First Name',
    lastName: 'Last Name',
    username: 'Username',
    email: 'Email',
    confirmPassword: 'Confirm Password',
    newsletterOptIn: 'Subscribe to our newsletter for updates and special offers',
    completeVerificationToRegister: 'Complete Verification to Register',
    createAccount: 'Create Account',
    creatingYourAccount: 'Creating Your Account...',
    // Password strength
    strengthTooWeak: 'Too weak',
    strengthWeak: 'Weak',
    strengthFair: 'Fair',
    strengthGood: 'Good',
    strengthStrong: 'Strong',
    strengthVeryStrong: 'Very strong',
    // Validation & toasts
    errUsernameRequired: 'Username is required',
    errUsernameShort: 'Username must be at least 3 characters',
    errUsernameChars: 'Username can only contain letters, numbers, underscores, and dashes',
    errEmailRequired: 'Email is required',
    errEmailInvalid: 'Please enter a valid email address',
    errPasswordRequired: 'Password is required',
    errPasswordShort: 'Password must be at least 6 characters',
    errConfirmRequired: 'Please confirm your password',
    errPasswordMismatch: 'Passwords do not match',
    errCaptcha: 'Please complete the human verification',
    errFixBelow: 'Please fix the errors below',
    errRegistrationFailed: 'Registration failed.',
    errRegistrationFailedRetry: 'Registration failed. Please try again.',
    errRegistrationGeneric: 'An error occurred during registration.',
    welcomeCheckEmail:
      'Welcome {name}! Please check your email (including spam) and click the verification link.',
    welcomeCheckEmailDev:
      'Welcome {name}! Check your email for the verification link. (Dev link logged to browser console.)',
    // Human-verification widget
    captchaHold: 'Hold to verify you are human',
    captchaHolding: 'Keep holding...',
    captchaSuccess: '✅ Verification Successful!',
    captchaIncomplete: 'Hold incomplete. Please try again.',
    captchaHoldButton: 'Hold to verify (1.5s)',
    captchaVerified: 'Verified',
    // Server-side auth errors
    srvInvalidCredentials: 'Invalid username or password.',
    srvUserNotFound: 'We could not find an account with those details.',
    srvUsernameTaken: 'This username is already taken. Please choose a different username.',
    srvEmailTaken:
      'This email address is already registered. Please use a different email or try logging in.',
    srvMultipleAccounts:
      'Multiple accounts use this email. Please sign in with your username instead.',
    srvVerificationUsed: 'This verification link has already been used. Please try logging in.',
    srvVerificationTokenFailed: 'Could not create a verification link. Please try again.',
    srvAccountDisabled: 'This account is deactivated. Please contact us for help.',
    srvServerError: 'Something went wrong on our side. Please try again.',
  },
  footer: {
    privacy: 'Privacy',
    terms: 'Terms',
    preferences: 'Preferences',
    returns: 'Returns',
    shipping: 'Shipping',
    faq: 'FAQ',
    contact: 'Contact',
    disclaimer:
      'No warranty. Use at your own risk. By using this site, you agree to our Terms and Privacy. Trademarks property of their owners.',
  },
};

const frCA = {
  nav: {
    home: 'Accueil',
    shop: 'Boutique',
    articles: 'Articles',
    tunes: 'Airs',
    abc: 'ABC',
    about: 'À propos',
    contact: 'Contact',
    faq: 'FAQ',
    search: 'Recherche',
    signUp: 'Inscription',
    login: 'Connexion',
    profile: 'Profil',
    admin: 'Tableau de bord',
    logout: 'Déconnexion',
    account: 'Compte',
    signedInAs: 'Connecté en tant que',
    welcome: 'Bienvenue',
    installApp: 'Installer l’appli',
    language: 'Langue',
    selectLanguage: 'Choisir la langue',
  },
  auth: {
    loginTitle: 'Connexion',
    noAccount: 'Vous n’avez pas de compte ?',
    signUpHere: 'Inscrivez-vous ici',
    forgotPassword: 'Mot de passe oublié ?',
    usernameOrEmail: 'Nom d’utilisateur ou courriel',
    usernameOrEmailPlaceholder: 'Entrez votre nom d’utilisateur ou votre courriel',
    password: 'Mot de passe',
    passwordPlaceholder: 'Entrez votre mot de passe',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    loginButton: 'Se connecter',
    loggingIn: 'Connexion en cours...',
    welcomeBack: 'Bon retour !',
    invalidCredentials: 'Nom d’utilisateur, courriel ou mot de passe invalide',
    loginFailed: 'La connexion a échoué. Veuillez réessayer.',
    signUpTitle: 'Inscription',
    playerCalloutTitle: 'Lecteur de musique avec plus de 70 airs gratuits !',
    playerCalloutText:
      'Inscrivez-vous pour accéder à notre lecteur exclusif d’airs de violon du Cap-Breton',
    creatingAccountSpinner: 'Création de votre compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signInHere: 'Connectez-vous ici',
    forgotYourPassword: 'Mot de passe oublié ?',
    devHint:
      'Test local : vous pouvez réutiliser le même courriel pour plusieurs comptes si chaque nom d’utilisateur est unique. Connectez-vous avec votre nom d’utilisateur lorsque plusieurs comptes partagent un courriel.',
    firstName: 'Prénom',
    lastName: 'Nom',
    username: 'Nom d’utilisateur',
    email: 'Courriel',
    confirmPassword: 'Confirmer le mot de passe',
    newsletterOptIn:
      'Abonnez-vous à notre infolettre pour recevoir les nouveautés et les offres spéciales',
    completeVerificationToRegister: 'Complétez la vérification pour vous inscrire',
    createAccount: 'Créer un compte',
    creatingYourAccount: 'Création de votre compte...',
    strengthTooWeak: 'Trop faible',
    strengthWeak: 'Faible',
    strengthFair: 'Moyen',
    strengthGood: 'Bon',
    strengthStrong: 'Fort',
    strengthVeryStrong: 'Très fort',
    errUsernameRequired: 'Le nom d’utilisateur est obligatoire',
    errUsernameShort: 'Le nom d’utilisateur doit compter au moins 3 caractères',
    errUsernameChars:
      'Le nom d’utilisateur ne peut contenir que des lettres, des chiffres, des traits de soulignement et des tirets',
    errEmailRequired: 'Le courriel est obligatoire',
    errEmailInvalid: 'Veuillez entrer une adresse de courriel valide',
    errPasswordRequired: 'Le mot de passe est obligatoire',
    errPasswordShort: 'Le mot de passe doit compter au moins 6 caractères',
    errConfirmRequired: 'Veuillez confirmer votre mot de passe',
    errPasswordMismatch: 'Les mots de passe ne correspondent pas',
    errCaptcha: 'Veuillez compléter la vérification anti-robot',
    errFixBelow: 'Veuillez corriger les erreurs ci-dessous',
    errRegistrationFailed: 'L’inscription a échoué.',
    errRegistrationFailedRetry: 'L’inscription a échoué. Veuillez réessayer.',
    errRegistrationGeneric: 'Une erreur est survenue pendant l’inscription.',
    welcomeCheckEmail:
      'Bienvenue {name} ! Veuillez consulter votre courriel (y compris les indésirables) et cliquer sur le lien de vérification.',
    welcomeCheckEmailDev:
      'Bienvenue {name} ! Consultez votre courriel pour le lien de vérification. (Lien de développement affiché dans la console du navigateur.)',
    captchaHold: 'Maintenez pour confirmer que vous êtes humain',
    captchaHolding: 'Continuez de maintenir...',
    captchaSuccess: '✅ Vérification réussie !',
    captchaIncomplete: 'Maintien incomplet. Veuillez réessayer.',
    captchaHoldButton: 'Maintenez pour vérifier (1,5 s)',
    captchaVerified: 'Vérifié',
    srvInvalidCredentials: 'Nom d’utilisateur ou mot de passe invalide.',
    srvUserNotFound: 'Aucun compte ne correspond à ces renseignements.',
    srvUsernameTaken:
      'Ce nom d’utilisateur est déjà pris. Veuillez en choisir un autre.',
    srvEmailTaken:
      'Ce courriel est déjà inscrit. Utilisez un autre courriel ou connectez-vous.',
    srvMultipleAccounts:
      'Plusieurs comptes utilisent ce courriel. Veuillez vous connecter avec votre nom d’utilisateur.',
    srvVerificationUsed:
      'Ce lien de vérification a déjà été utilisé. Veuillez essayer de vous connecter.',
    srvVerificationTokenFailed:
      'Impossible de créer le lien de vérification. Veuillez réessayer.',
    srvAccountDisabled: 'Ce compte est désactivé. Veuillez nous contacter pour obtenir de l’aide.',
    srvServerError: 'Une erreur est survenue de notre côté. Veuillez réessayer.',
  },
  footer: {
    privacy: 'Confidentialité',
    terms: 'Conditions',
    preferences: 'Préférences',
    returns: 'Retours',
    shipping: 'Livraison',
    faq: 'FAQ',
    contact: 'Contact',
    disclaimer:
      'Aucune garantie. Utilisation à vos risques. En utilisant ce site, vous acceptez nos conditions et notre politique de confidentialité. Les marques appartiennent à leurs propriétaires.',
  },
};

const frFR = {
  nav: {
    home: 'Accueil',
    shop: 'Boutique',
    articles: 'Articles',
    tunes: 'Airs',
    abc: 'ABC',
    about: 'À propos',
    contact: 'Contact',
    faq: 'FAQ',
    search: 'Recherche',
    signUp: 'Inscription',
    login: 'Connexion',
    profile: 'Profil',
    admin: 'Administration',
    logout: 'Déconnexion',
    account: 'Compte',
    signedInAs: 'Connecté en tant que',
    welcome: 'Bienvenue',
    installApp: 'Installer l’application',
    language: 'Langue',
    selectLanguage: 'Choisir la langue',
  },
  auth: {
    loginTitle: 'Connexion',
    noAccount: 'Vous n’avez pas de compte ?',
    signUpHere: 'Inscrivez-vous ici',
    forgotPassword: 'Mot de passe oublié ?',
    usernameOrEmail: 'Nom d’utilisateur ou e-mail',
    usernameOrEmailPlaceholder: 'Saisissez votre nom d’utilisateur ou votre e-mail',
    password: 'Mot de passe',
    passwordPlaceholder: 'Saisissez votre mot de passe',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    loginButton: 'Se connecter',
    loggingIn: 'Connexion en cours...',
    welcomeBack: 'Content de vous revoir !',
    invalidCredentials: 'Nom d’utilisateur, e-mail ou mot de passe invalide',
    loginFailed: 'La connexion a échoué. Veuillez réessayer.',
    signUpTitle: 'Inscription',
    playerCalloutTitle: 'Lecteur de musique avec plus de 70 airs gratuits !',
    playerCalloutText:
      'Inscrivez-vous pour accéder à notre lecteur exclusif d’airs de violon du Cap-Breton',
    creatingAccountSpinner: 'Création de votre compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signInHere: 'Connectez-vous ici',
    forgotYourPassword: 'Mot de passe oublié ?',
    devHint:
      'Test local : vous pouvez réutiliser la même adresse e-mail pour plusieurs comptes si chaque nom d’utilisateur est unique. Connectez-vous avec votre nom d’utilisateur lorsque plusieurs comptes partagent une adresse.',
    firstName: 'Prénom',
    lastName: 'Nom',
    username: 'Nom d’utilisateur',
    email: 'E-mail',
    confirmPassword: 'Confirmer le mot de passe',
    newsletterOptIn:
      'Abonnez-vous à notre newsletter pour recevoir les actualités et les offres spéciales',
    completeVerificationToRegister: 'Complétez la vérification pour vous inscrire',
    createAccount: 'Créer un compte',
    creatingYourAccount: 'Création de votre compte...',
    strengthTooWeak: 'Trop faible',
    strengthWeak: 'Faible',
    strengthFair: 'Moyen',
    strengthGood: 'Bon',
    strengthStrong: 'Fort',
    strengthVeryStrong: 'Très fort',
    errUsernameRequired: 'Le nom d’utilisateur est obligatoire',
    errUsernameShort: 'Le nom d’utilisateur doit comporter au moins 3 caractères',
    errUsernameChars:
      'Le nom d’utilisateur ne peut contenir que des lettres, des chiffres, des tirets bas et des tirets',
    errEmailRequired: 'L’adresse e-mail est obligatoire',
    errEmailInvalid: 'Veuillez saisir une adresse e-mail valide',
    errPasswordRequired: 'Le mot de passe est obligatoire',
    errPasswordShort: 'Le mot de passe doit comporter au moins 6 caractères',
    errConfirmRequired: 'Veuillez confirmer votre mot de passe',
    errPasswordMismatch: 'Les mots de passe ne correspondent pas',
    errCaptcha: 'Veuillez compléter la vérification anti-robot',
    errFixBelow: 'Veuillez corriger les erreurs ci-dessous',
    errRegistrationFailed: 'L’inscription a échoué.',
    errRegistrationFailedRetry: 'L’inscription a échoué. Veuillez réessayer.',
    errRegistrationGeneric: 'Une erreur est survenue pendant l’inscription.',
    welcomeCheckEmail:
      'Bienvenue {name} ! Consultez votre boîte e-mail (y compris les spams) et cliquez sur le lien de vérification.',
    welcomeCheckEmailDev:
      'Bienvenue {name} ! Consultez votre e-mail pour le lien de vérification. (Lien de développement affiché dans la console du navigateur.)',
    captchaHold: 'Maintenez pour confirmer que vous êtes humain',
    captchaHolding: 'Continuez d’appuyer...',
    captchaSuccess: '✅ Vérification réussie !',
    captchaIncomplete: 'Appui incomplet. Veuillez réessayer.',
    captchaHoldButton: 'Maintenez pour vérifier (1,5 s)',
    captchaVerified: 'Vérifié',
    srvInvalidCredentials: 'Nom d’utilisateur ou mot de passe invalide.',
    srvUserNotFound: 'Aucun compte ne correspond à ces informations.',
    srvUsernameTaken:
      'Ce nom d’utilisateur est déjà pris. Veuillez en choisir un autre.',
    srvEmailTaken:
      'Cette adresse e-mail est déjà enregistrée. Utilisez une autre adresse ou connectez-vous.',
    srvMultipleAccounts:
      'Plusieurs comptes utilisent cette adresse e-mail. Veuillez vous connecter avec votre nom d’utilisateur.',
    srvVerificationUsed:
      'Ce lien de vérification a déjà été utilisé. Veuillez essayer de vous connecter.',
    srvVerificationTokenFailed:
      'Impossible de créer le lien de vérification. Veuillez réessayer.',
    srvAccountDisabled: 'Ce compte est désactivé. Veuillez nous contacter pour obtenir de l’aide.',
    srvServerError: 'Une erreur est survenue de notre côté. Veuillez réessayer.',
  },
  footer: {
    privacy: 'Confidentialité',
    terms: 'Mentions légales',
    preferences: 'Préférences',
    returns: 'Retours',
    shipping: 'Livraison',
    faq: 'FAQ',
    contact: 'Contact',
    disclaimer:
      'Aucune garantie. Utilisation à vos risques. En utilisant ce site, vous acceptez nos conditions et notre politique de confidentialité. Les marques appartiennent à leurs propriétaires.',
  },
};

const de = {
  nav: {
    home: 'Startseite',
    shop: 'Shop',
    articles: 'Artikel',
    tunes: 'Musik',
    abc: 'ABC',
    about: 'Über uns',
    contact: 'Kontakt',
    faq: 'FAQ',
    search: 'Suche',
    signUp: 'Registrieren',
    login: 'Anmelden',
    profile: 'Profil',
    admin: 'Admin-Bereich',
    logout: 'Abmelden',
    account: 'Konto',
    signedInAs: 'Angemeldet als',
    welcome: 'Willkommen',
    installApp: 'App installieren',
    language: 'Sprache',
    selectLanguage: 'Sprache wählen',
  },
  auth: {
    loginTitle: 'Anmelden',
    noAccount: 'Noch kein Konto?',
    signUpHere: 'Hier registrieren',
    forgotPassword: 'Passwort vergessen?',
    usernameOrEmail: 'Benutzername oder E-Mail',
    usernameOrEmailPlaceholder: 'Benutzernamen oder E-Mail eingeben',
    password: 'Passwort',
    passwordPlaceholder: 'Passwort eingeben',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    loginButton: 'Anmelden',
    loggingIn: 'Anmeldung läuft...',
    welcomeBack: 'Willkommen zurück!',
    invalidCredentials: 'Benutzername, E-Mail oder Passwort ist ungültig',
    loginFailed: 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    signUpTitle: 'Registrieren',
    playerCalloutTitle: 'Musikplayer mit über 70 kostenlosen Melodien!',
    playerCalloutText:
      'Registrieren Sie sich, um unseren exklusiven Player mit Fiddle-Melodien aus Cape Breton freizuschalten',
    creatingAccountSpinner: 'Ihr Konto wird erstellt...',
    alreadyHaveAccount: 'Sie haben schon ein Konto?',
    signInHere: 'Hier anmelden',
    forgotYourPassword: 'Passwort vergessen?',
    devHint:
      'Lokaler Test: Sie können dieselbe E-Mail-Adresse für mehrere Konten verwenden, solange jeder Benutzername eindeutig ist. Melden Sie sich mit dem Benutzernamen an, wenn mehrere Konten eine E-Mail-Adresse teilen.',
    firstName: 'Vorname',
    lastName: 'Nachname',
    username: 'Benutzername',
    email: 'E-Mail',
    confirmPassword: 'Passwort bestätigen',
    newsletterOptIn: 'Newsletter für Neuigkeiten und Sonderangebote abonnieren',
    completeVerificationToRegister: 'Verifizierung abschließen, um zu registrieren',
    createAccount: 'Konto erstellen',
    creatingYourAccount: 'Konto wird erstellt...',
    strengthTooWeak: 'Zu schwach',
    strengthWeak: 'Schwach',
    strengthFair: 'Mittel',
    strengthGood: 'Gut',
    strengthStrong: 'Stark',
    strengthVeryStrong: 'Sehr stark',
    errUsernameRequired: 'Benutzername ist erforderlich',
    errUsernameShort: 'Der Benutzername muss mindestens 3 Zeichen lang sein',
    errUsernameChars:
      'Der Benutzername darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten',
    errEmailRequired: 'E-Mail-Adresse ist erforderlich',
    errEmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    errPasswordRequired: 'Passwort ist erforderlich',
    errPasswordShort: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    errConfirmRequired: 'Bitte bestätigen Sie Ihr Passwort',
    errPasswordMismatch: 'Die Passwörter stimmen nicht überein',
    errCaptcha: 'Bitte schließen Sie die Sicherheitsprüfung ab',
    errFixBelow: 'Bitte korrigieren Sie die Fehler unten',
    errRegistrationFailed: 'Registrierung fehlgeschlagen.',
    errRegistrationFailedRetry: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    errRegistrationGeneric: 'Bei der Registrierung ist ein Fehler aufgetreten.',
    welcomeCheckEmail:
      'Willkommen {name}! Bitte prüfen Sie Ihre E-Mails (auch den Spam-Ordner) und klicken Sie auf den Verifizierungslink.',
    welcomeCheckEmailDev:
      'Willkommen {name}! Prüfen Sie Ihre E-Mails auf den Verifizierungslink. (Dev-Link in der Browser-Konsole ausgegeben.)',
    captchaHold: 'Halten, um zu bestätigen, dass Sie ein Mensch sind',
    captchaHolding: 'Weiter halten...',
    captchaSuccess: '✅ Verifizierung erfolgreich!',
    captchaIncomplete: 'Halten unvollständig. Bitte versuchen Sie es erneut.',
    captchaHoldButton: 'Halten zum Verifizieren (1,5 s)',
    captchaVerified: 'Verifiziert',
    srvInvalidCredentials: 'Benutzername oder Passwort ist ungültig.',
    srvUserNotFound: 'Zu diesen Angaben wurde kein Konto gefunden.',
    srvUsernameTaken:
      'Dieser Benutzername ist bereits vergeben. Bitte wählen Sie einen anderen.',
    srvEmailTaken:
      'Diese E-Mail-Adresse ist bereits registriert. Bitte verwenden Sie eine andere Adresse oder melden Sie sich an.',
    srvMultipleAccounts:
      'Mehrere Konten nutzen diese E-Mail-Adresse. Bitte melden Sie sich mit Ihrem Benutzernamen an.',
    srvVerificationUsed:
      'Dieser Verifizierungslink wurde bereits verwendet. Bitte melden Sie sich an.',
    srvVerificationTokenFailed:
      'Der Verifizierungslink konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    srvAccountDisabled: 'Dieses Konto ist deaktiviert. Bitte kontaktieren Sie uns.',
    srvServerError: 'Auf unserer Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  },
  footer: {
    privacy: 'Datenschutz',
    terms: 'AGB',
    preferences: 'Einstellungen',
    returns: 'Rücksendungen',
    shipping: 'Versand',
    faq: 'FAQ',
    contact: 'Kontakt',
    disclaimer:
      'Keine Gewähr. Nutzung auf eigene Gefahr. Mit der Nutzung dieser Website stimmen Sie unseren AGB und der Datenschutzerklärung zu. Marken gehören ihren Inhabern.',
  },
};

/**
 * Irish (Gaeilge) — chrome only. Page bodies fall back to the English CMS
 * content until translated copy exists.
 */
const ga = {
  nav: {
    home: 'Baile',
    shop: 'Siopa',
    articles: 'Ailt',
    tunes: 'Poirt',
    abc: 'ABC',
    about: 'Fúinn',
    contact: 'Teagmháil',
    faq: 'Ceisteanna',
    search: 'Cuardach',
    signUp: 'Cláraigh',
    login: 'Logáil isteach',
    profile: 'Próifíl',
    admin: 'Painéal riaracháin',
    logout: 'Logáil amach',
    account: 'Cuntas',
    signedInAs: 'Logáilte isteach mar',
    welcome: 'Fáilte',
    installApp: 'Suiteáil an aip',
    language: 'Teanga',
    selectLanguage: 'Roghnaigh teanga',
  },
  auth: {
    loginTitle: 'Logáil isteach',
    noAccount: 'Níl cuntas agat?',
    signUpHere: 'Cláraigh anseo',
    forgotPassword: 'Focal faire dearmadta?',
    usernameOrEmail: 'Ainm úsáideora nó ríomhphost',
    usernameOrEmailPlaceholder: 'Cuir isteach do ainm úsáideora nó ríomhphost',
    password: 'Focal faire',
    passwordPlaceholder: 'Cuir isteach do fhocal faire',
    showPassword: 'Taispeáin an focal faire',
    hidePassword: 'Cuir an focal faire i bhfolach',
    loginButton: 'Logáil isteach',
    loggingIn: 'Ag logáil isteach...',
    welcomeBack: 'Fáilte ar ais!',
    invalidCredentials: 'Ainm úsáideora, ríomhphost nó focal faire mícheart',
    loginFailed: 'Theip ar an logáil isteach. Bain triail eile as.',
    signUpTitle: 'Cláraigh',
    playerCalloutTitle: 'Seinnteoir ceoil le breis is 70 port saor in aisce!',
    playerCalloutText:
      'Cláraigh chun teacht ar ár seinnteoir port fidile ó Cheap Breatainn',
    creatingAccountSpinner: 'Do chuntas á chruthú...',
    alreadyHaveAccount: 'An bhfuil cuntas agat cheana?',
    signInHere: 'Logáil isteach anseo',
    forgotYourPassword: 'Focal faire dearmadta?',
    devHint:
      'Tástáil áitiúil: is féidir an ríomhphost céanna a úsáid ar níos mó ná cuntas amháin fad is atá gach ainm úsáideora uathúil. Logáil isteach le do ainm úsáideora nuair a roinneann cuntais ríomhphost.',
    firstName: 'Céadainm',
    lastName: 'Sloinne',
    username: 'Ainm úsáideora',
    email: 'Ríomhphost',
    confirmPassword: 'Deimhnigh an focal faire',
    newsletterOptIn: 'Liostáil lenár nuachtlitir le nuacht agus tairiscintí speisialta',
    completeVerificationToRegister: 'Críochnaigh an fíorú chun clárú',
    createAccount: 'Cruthaigh cuntas',
    creatingYourAccount: 'Do chuntas á chruthú...',
    strengthTooWeak: 'Ró-lag',
    strengthWeak: 'Lag',
    strengthFair: 'Measartha',
    strengthGood: 'Maith',
    strengthStrong: 'Láidir',
    strengthVeryStrong: 'An-láidir',
    errUsernameRequired: 'Tá ainm úsáideora riachtanach',
    errUsernameShort: 'Caithfidh 3 charachtar ar a laghad a bheith san ainm úsáideora',
    errUsernameChars:
      'Ní cheadaítear ach litreacha, uimhreacha, fostríoca agus fleiscíní san ainm úsáideora',
    errEmailRequired: 'Tá ríomhphost riachtanach',
    errEmailInvalid: 'Cuir isteach seoladh ríomhphoist bailí',
    errPasswordRequired: 'Tá focal faire riachtanach',
    errPasswordShort: 'Caithfidh 6 charachtar ar a laghad a bheith sa bhfocal faire',
    errConfirmRequired: 'Deimhnigh do fhocal faire',
    errPasswordMismatch: 'Níl na focail faire mar an gcéanna',
    errCaptcha: 'Críochnaigh an fíorú daonna',
    errFixBelow: 'Ceartaigh na hearráidí thíos',
    errRegistrationFailed: 'Theip ar an gclárú.',
    errRegistrationFailedRetry: 'Theip ar an gclárú. Bain triail eile as.',
    errRegistrationGeneric: 'Tharla earráid le linn an chláraithe.',
    welcomeCheckEmail:
      'Fáilte {name}! Seiceáil do ríomhphost (an fillteán turscair san áireamh) agus cliceáil an nasc fíoraithe.',
    welcomeCheckEmailDev:
      'Fáilte {name}! Seiceáil do ríomhphost don nasc fíoraithe. (Nasc forbartha sa chonsól.)',
    captchaHold: 'Coinnigh síos chun a fhíorú gur duine tú',
    captchaHolding: 'Coinnigh síos é...',
    captchaSuccess: '✅ D’éirigh leis an bhfíorú!',
    captchaIncomplete: 'Níor coinníodh síos é fada go leor. Bain triail eile as.',
    captchaHoldButton: 'Coinnigh síos chun fíorú (1.5s)',
    captchaVerified: 'Fíoraithe',
    srvInvalidCredentials: 'Ainm úsáideora nó focal faire mícheart.',
    srvUserNotFound: 'Níorbh fhéidir cuntas a aimsiú leis na sonraí sin.',
    srvUsernameTaken: 'Tá an ainm úsáideora sin in úsáid cheana. Roghnaigh ceann eile.',
    srvEmailTaken:
      'Tá an seoladh ríomhphoist sin cláraithe cheana. Úsáid ceann eile nó logáil isteach.',
    srvMultipleAccounts:
      'Úsáideann níos mó ná cuntas amháin an ríomhphost sin. Logáil isteach le do ainm úsáideora.',
    srvVerificationUsed: 'Baineadh úsáid as an nasc fíoraithe seo cheana. Logáil isteach le do thoil.',
    srvVerificationTokenFailed: 'Níorbh fhéidir nasc fíoraithe a chruthú. Bain triail eile as.',
    srvAccountDisabled: 'Tá an cuntas seo díchumasaithe. Déan teagmháil linn le cabhair.',
    srvServerError: 'Chuaigh rud éigin mícheart ar ár dtaobh. Bain triail eile as.',
  },
  footer: {
    privacy: 'Príobháideachas',
    terms: 'Téarmaí',
    preferences: 'Roghanna',
    returns: 'Earraí ar ais',
    shipping: 'Seachadadh',
    faq: 'Ceisteanna',
    contact: 'Teagmháil',
    disclaimer:
      'Gan bharánta. Úsáid ar do phriacal féin. Trí úsáid a bhaint as an suíomh seo, aontaíonn tú lenár dtéarmaí agus lenár bpolasaí príobháideachais. Is le húinéirí faoi seach na trádmharcanna.',
  },
};

/**
 * Scottish Gaelic (Gàidhlig) — chrome only. Page bodies fall back to the
 * English CMS content until translated copy exists.
 */
const gd = {
  nav: {
    home: 'Dachaigh',
    shop: 'Bùth',
    articles: 'Aistean',
    tunes: 'Puirt',
    abc: 'ABC',
    about: 'Mu dheidhinn',
    contact: 'Cuir fios',
    faq: 'Ceistean',
    search: 'Lorg',
    signUp: 'Clàraich',
    login: 'Log a-steach',
    profile: 'Pròifil',
    admin: 'Panail rianachd',
    logout: 'Log a-mach',
    account: 'Cunntas',
    signedInAs: 'Air do chlàradh a-steach mar',
    welcome: 'Fàilte',
    installApp: 'Stàlaich an aplacaid',
    language: 'Cànan',
    selectLanguage: 'Tagh cànan',
  },
  auth: {
    loginTitle: 'Log a-steach',
    noAccount: 'Nach eil cunntas agad?',
    signUpHere: 'Clàraich an seo',
    forgotPassword: 'Facal-faire air chall?',
    usernameOrEmail: 'Ainm-cleachdaiche no post-d',
    usernameOrEmailPlaceholder: 'Cuir a-steach an ainm-cleachdaiche no post-d agad',
    password: 'Facal-faire',
    passwordPlaceholder: 'Cuir a-steach am facal-faire agad',
    showPassword: 'Seall am facal-faire',
    hidePassword: 'Falaich am facal-faire',
    loginButton: 'Log a-steach',
    loggingIn: 'A’ logadh a-steach...',
    welcomeBack: 'Fàilte air ais!',
    invalidCredentials: 'Ainm-cleachdaiche, post-d no facal-faire ceàrr',
    loginFailed: 'Dh’fhàillig an logadh a-steach. Feuch ris a-rithist.',
    signUpTitle: 'Clàraich',
    playerCalloutTitle: 'Cluicheadair ciùil le còrr air 70 port an-asgaidh!',
    playerCalloutText:
      'Clàraich airson cothrom air a’ chluicheadair phort fidhle againn bho Cheap Breatainn',
    creatingAccountSpinner: 'A’ cruthachadh do chunntas...',
    alreadyHaveAccount: 'A bheil cunntas agad mar-thà?',
    signInHere: 'Log a-steach an seo',
    forgotYourPassword: 'Facal-faire air chall?',
    devHint:
      'Deuchainn ionadail: faodaidh tu an aon phost-d a chleachdadh air iomadh cunntas fhad ’s a tha gach ainm-cleachdaiche air leth. Log a-steach le d’ ainm-cleachdaiche nuair a bhios post-d aig grunn chunntasan.',
    firstName: 'Ainm',
    lastName: 'Sloinneadh',
    username: 'Ainm-cleachdaiche',
    email: 'Post-d',
    confirmPassword: 'Dearbh am facal-faire',
    newsletterOptIn: 'Gabh ballrachd sa chuairt-litir againn airson naidheachdan agus tabhartasan',
    completeVerificationToRegister: 'Coilean an dearbhadh airson clàradh',
    createAccount: 'Cruthaich cunntas',
    creatingYourAccount: 'A’ cruthachadh do chunntas...',
    strengthTooWeak: 'Ro lag',
    strengthWeak: 'Lag',
    strengthFair: 'Meadhanach',
    strengthGood: 'Math',
    strengthStrong: 'Làidir',
    strengthVeryStrong: 'Glè làidir',
    errUsernameRequired: 'Tha feum air ainm-cleachdaiche',
    errUsernameShort: 'Feumaidh 3 caractaran a bhith san ainm-cleachdaiche air a’ char as lugha',
    errUsernameChars:
      'Chan fhaod ach litrichean, àireamhan, fo-loidhnichean agus tàthanan a bhith san ainm-cleachdaiche',
    errEmailRequired: 'Tha feum air post-d',
    errEmailInvalid: 'Cuir a-steach seòladh puist-d dligheach',
    errPasswordRequired: 'Tha feum air facal-faire',
    errPasswordShort: 'Feumaidh 6 caractaran a bhith sa facal-faire air a’ char as lugha',
    errConfirmRequired: 'Dearbh am facal-faire agad',
    errPasswordMismatch: 'Chan eil na faclan-faire co-ionann',
    errCaptcha: 'Coilean an dearbhadh daonna',
    errFixBelow: 'Cuir ceart na mearachdan gu h-ìosal',
    errRegistrationFailed: 'Dh’fhàillig an clàradh.',
    errRegistrationFailedRetry: 'Dh’fhàillig an clàradh. Feuch ris a-rithist.',
    errRegistrationGeneric: 'Thachair mearachd rè a’ chlàraidh.',
    welcomeCheckEmail:
      'Fàilte {name}! Thoir sùil air a’ phost-d agad (a’ gabhail a-steach spama) agus briog air an ceangal dearbhaidh.',
    welcomeCheckEmailDev:
      'Fàilte {name}! Thoir sùil air a’ phost-d agad airson an ceangal dearbhaidh. (Ceangal leasachaidh sa chonsol.)',
    captchaHold: 'Cùm sìos airson dearbhadh gur e duine a tha thu',
    captchaHolding: 'Cùm sìos e...',
    captchaSuccess: '✅ Chaidh an dearbhadh troimhe!',
    captchaIncomplete: 'Cha do chum thu sìos e fada gu leòr. Feuch ris a-rithist.',
    captchaHoldButton: 'Cùm sìos airson dearbhadh (1.5s)',
    captchaVerified: 'Dearbhte',
    srvInvalidCredentials: 'Ainm-cleachdaiche no facal-faire ceàrr.',
    srvUserNotFound: 'Cha b’ urrainn dhuinn cunntas a lorg leis an fhiosrachadh sin.',
    srvUsernameTaken: 'Tha an ainm-cleachdaiche sin air a chleachdadh mar-thà. Tagh fear eile.',
    srvEmailTaken:
      'Tha an seòladh puist-d sin clàraichte mar-thà. Cleachd fear eile no log a-steach.',
    srvMultipleAccounts:
      'Tha grunn chunntasan a’ cleachdadh a’ phuist-d sin. Log a-steach le d’ ainm-cleachdaiche.',
    srvVerificationUsed: 'Chaidh an ceangal dearbhaidh seo a chleachdadh mar-thà. Log a-steach.',
    srvVerificationTokenFailed:
      'Cha b’ urrainn dhuinn ceangal dearbhaidh a chruthachadh. Feuch ris a-rithist.',
    srvAccountDisabled: 'Chaidh an cunntas seo a chur à comas. Cuir fios thugainn airson cuideachadh.',
    srvServerError: 'Chaidh rudeigin ceàrr air ar taobh. Feuch ris a-rithist.',
  },
  footer: {
    privacy: 'Prìobhaideachd',
    terms: 'Teirmichean',
    preferences: 'Roghainnean',
    returns: 'Tillidhean',
    shipping: 'Lìbhrigeadh',
    faq: 'Ceistean',
    contact: 'Fios thugainn',
    disclaimer:
      'Gun bharantas. Cleachd air do chunnart fhèin. Le bhith a’ cleachdadh na làraich seo, tha tu ag aontachadh ris na teirmichean agus ris a’ phoileasaidh phrìobhaideachd againn. Buinidh comharran-malairt dan sealbhadairean fhèin.',
  },
};

/**
 * US English shares the Canadian English chrome; only spelling that actually
 * differs is overridden here.
 */
const enUS = {
  ...en,
  nav: { ...en.nav },
  auth: { ...en.auth },
  footer: { ...en.footer },
};

/**
 * British English — same chrome, with the wording UK shoppers expect
 * ("Delivery" rather than "Shipping").
 */
const enGB = {
  ...en,
  nav: { ...en.nav },
  auth: { ...en.auth },
  footer: { ...en.footer, shipping: 'Delivery' },
};

/** App-framework chrome (share, theme, bug report, forms) lives in ./ui. Shop/cart/checkout in ./shop. */
export const MESSAGES = {
  en: { ...en, ui: UI_MESSAGES.en, shop: SHOP_MESSAGES.en },
  'en-US': { ...enUS, ui: UI_MESSAGES['en-US'], shop: SHOP_MESSAGES['en-US'] },
  'en-GB': { ...enGB, ui: UI_MESSAGES['en-GB'], shop: SHOP_MESSAGES['en-GB'] },
  'fr-CA': { ...frCA, ui: UI_MESSAGES['fr-CA'], shop: SHOP_MESSAGES['fr-CA'] },
  'fr-FR': { ...frFR, ui: UI_MESSAGES['fr-FR'], shop: SHOP_MESSAGES['fr-FR'] },
  de: { ...de, ui: UI_MESSAGES.de, shop: SHOP_MESSAGES.de },
  ga: { ...ga, ui: UI_MESSAGES.ga, shop: SHOP_MESSAGES.ga },
  gd: { ...gd, ui: UI_MESSAGES.gd, shop: SHOP_MESSAGES.gd },
};
